(() => {
  if (window.FFHomeReviewImages) {
    window.FFHomeReviewImages.initialize();
    return;
  }
  const instances = new Map();
  let discovery;
  const selector = 'img.jdgm-carousel-item__product-image[data-src]';
  function initialize() {
    if (!document.querySelector('[data-ff-home-interactions]')) return;
    const roots = document.querySelectorAll('#main .jdgm-carousel-wrapper');
    if (roots.length) discovery?.disconnect();
    roots.forEach(root => {
      if (instances.has(root)) return;
      const prepared = new WeakSet();
      function load(image) {
        if (image.getAttribute('src')) return;
        const source = image.dataset.src;
        if (!source) return;
        const retina = image.dataset.srcRetina;
        if (retina && !image.hasAttribute('srcset')) image.srcset = `${source} 1x, ${retina} 2x`;
        image.addEventListener('error', () => {
          if (!image.hasAttribute('srcset')) return;
          image.removeAttribute('srcset');
          image.src = source;
        }, {once: true});
        image.src = source;
      }
      const intersection = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          load(entry.target);
          intersection.unobserve(entry.target);
        });
      }, {rootMargin: '400px'}) : null;
      function scan(scope = root) {
        const images = [...scope.querySelectorAll(selector)];
        if (scope.matches?.(selector)) images.unshift(scope);
        images.forEach(image => {
          if (prepared.has(image) || image.getAttribute('src')) return;
          prepared.add(image);
          image.decoding = 'async';
          image.width = 70;
          image.height = 70;
          if (intersection) intersection.observe(image);
          else load(image);
        });
      }
      const mutations = new MutationObserver(records => {
        records.forEach(record => {
          if (record.type === 'attributes') {
            if (record.target.matches(selector) && !record.target.getAttribute('src')) load(record.target);
          } else record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); });
        });
      });
      mutations.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-src', 'data-src-retina']});
      instances.set(root, () => { mutations.disconnect(); intersection?.disconnect(); });
      scan();
    });
  }
  const main = document.querySelector('#main');
  discovery = main ? new MutationObserver(() => initialize()) : null;
  discovery?.observe(main, {childList: true, subtree: true});
  window.FFHomeReviewImages = {initialize};
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, root) => {
      if (!event.target.contains(root)) return;
      cleanup();
      instances.delete(root);
    });
  });
  window.addEventListener('pagehide', () => {
    instances.forEach(cleanup => cleanup());
    instances.clear();
    discovery?.disconnect();
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    discovery?.observe(main, {childList: true, subtree: true});
    initialize();
  });
  initialize();
})();
